import { useState } from 'react'

export default function Tooltip({ text, children }) {
  const [visible, setVisible] = useState(false)

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible && text && (
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 z-[9999] pointer-events-none">
          <span className="block bg-slate-800 text-white text-xs rounded-lg px-3 py-1.5 shadow-lg w-56 text-center leading-snug whitespace-normal">
            {text}
          </span>
          <span className="block w-2 h-2 bg-slate-800 rotate-45 mx-auto -mt-1" />
        </span>
      )}
    </span>
  )
}
